import { render, staticRenderFns } from "./LabelDataTitle.vue?vue&type=template&id=212ff91a&scoped=true"
import script from "./LabelDataTitle.vue?vue&type=script&lang=js"
export * from "./LabelDataTitle.vue?vue&type=script&lang=js"
import style0 from "./LabelDataTitle.vue?vue&type=style&index=0&id=212ff91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ff91a",
  null
  
)

export default component.exports